<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row" v-if="!!salesOrder.id">
            <div class="col-8">
              <h3 class="mb-0 view-header-buttons">
                {{ salesOrder.seq_number ?? salesOrder.code }}
                <base-button
                  type="primary"
                  icon
                  size="sm"
                  @click="editSalesOrder()"
                  v-if="salesOrder.status === ORDER_STATUS_DRAFT"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="
                    salesOrder.status === ORDER_STATUS_DRAFT &&
                    $currentUserCan($permissions.PERM_DELETE_SALES_ORDERS)
                  "
                  type="danger"
                  icon
                  size="sm"
                  @click="deleteSalesOrder()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-trash"></i>
                  </span>
                </base-button>

                <base-button
                  type="primary"
                  icon
                  size="sm"
                  @click="validateSalesOrder()"
                  :disabled="loading"
                  v-if="
                    salesOrder.items.length > 0 &&
                    salesOrder.status === ORDER_STATUS_DRAFT &&
                    !isEstablishmentInactive
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-check-bold"></i>
                    {{ $t("SALES_ORDERS.VALIDATE") }}
                  </span>
                </base-button>

                <base-button
                  type="primary"
                  icon
                  size="sm"
                  @click="revertToDraft()"
                  :disabled="loading"
                  v-if="
                    salesOrder.status === ORDER_STATUS_VALIDATED &&
                    salesOrder.invoicing_status != INVOICING_STATUS_INVOICED
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-undo"></i>
                    {{ $t("SALES_ORDERS.REVERT_TO_DRAFT") }}
                  </span>
                </base-button>

                <!-- <base-button
                  type="primary"
                  icon
                  size="sm"
                  @click="
                    () => {
                      salesOrderInvoiceFormModalOpened = true;
                    }
                  "
                  :disabled="loading"
                  v-if="
                    salesOrder.status == ORDER_STATUS_VALIDATED &&
                    salesOrder.invoicing_status != INVOICING_STATUS_INVOICED &&
                    salesOrder.client_validated_status ==
                      CLIENT_VALIDATED_STATUS_VALIDATED
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-single-copy-04"></i>
                    {{ $t("SALES_ORDERS.ADD_INVOICE") }}
                  </span>
                </base-button> -->

                <base-button
                  type="primary"
                  icon
                  size="sm"
                  @click="
                    () => {
                      salesOrderDeliveryFormModalOpened = true;
                    }
                  "
                  :disabled="loading"
                  v-if="
                    $currentUserCan(
                      $permissions.PERM_CREATE_SALES_DELIVERIES
                    ) &&
                    salesOrder.status == ORDER_STATUS_VALIDATED &&
                    salesOrder.delivery_status != DELIVERY_STATUS_DELIVERED
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-truck"></i>
                    {{ $t("SALES_ORDERS.ADD_DELIVERY") }}
                  </span>
                </base-button>

                <base-button
                  type="danger"
                  icon
                  size="sm"
                  @click="cancelSalesOrder()"
                  :disabled="loading"
                  v-if="canCancelSalesOrder"
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-fat-remove"></i>
                    {{ $t("SALES_ORDERS.CANCEL") }}
                  </span>
                </base-button>

                <base-button
                  type="info"
                  icon
                  size="sm"
                  @click="print()"
                  :disabled="loading"
                  v-if="
                    salesOrder.status !== ORDER_STATUS_DRAFT &&
                    salesOrder.status !== ORDER_STATUS_CANCELED
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-file-pdf"></i>
                    {{ $t("COMMON.PRINT") }}
                  </span>
                </base-button>

                <base-button
                  type="success"
                  icon
                  size="sm"
                  @click="toggleMailModal()"
                  :disabled="loading"
                  v-if="
                    !usesInvoiceDispatchFlow &&
                    salesOrder.status !== ORDER_STATUS_DRAFT &&
                    salesOrder.status !== ORDER_STATUS_CANCELED &&
                    [CLIENT_VALIDATED_STATUS_DRAFT, CLIENT_VALIDATED_STATUS_PENDING].includes(salesOrder.client_validated_status)
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-envelope"></i>
                    {{ $t("COMMON.SEND") }}
                  </span>
                </base-button>

                <base-button
                  :type="subsidizedInvoiceAlreadySent ? 'warning' : 'success'"
                  icon
                  size="sm"
                  @click="openSubsidizedInvoiceModal()"
                  :disabled="loading || !salesOrder.event_date"
                  :title="!salesOrder.event_date ? $t('SALES_ORDERS.INVOICING_DATE_FALLBACK_WARNING') : ''"
                  v-if="
                    usesInvoiceDispatchFlow &&
                    salesOrder.status === ORDER_STATUS_VALIDATED &&
                    $currentUserCan($permissions.PERM_EDIT_SALES_ORDERS) &&
                    (salesOrder.pricing_type !== PRICING_TYPE_COUPONS ||
                      $currentUserCan($permissions.PERM_CREATE_COUPONS_SALES_ORDERS))
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-envelope"></i>
                    {{ subsidizedInvoiceAlreadySent
                      ? $t("SALES_ORDERS.RESEND_INVOICE")
                      : $t("SALES_ORDERS.GENERATE_AND_SEND_INVOICE") }}
                  </span>
                </base-button>

                <base-button
                  type="info"
                  icon
                  size="sm"
                  @click="recalculatePricing()"
                  :disabled="loading"
                  v-if="
                    salesOrder.status !== ORDER_STATUS_CANCELED &&
                    $currentUserCan($permissions.PERM_EDIT_SALES_ORDERS)
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-calculator"></i>
                    {{ $t("COMMON.RECALCULATE") }}
                  </span>
                </base-button>
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack()"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>

              <notification-subscription
                :objectType="'sales-orders'"
                :objectId="salesOrder.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>
        <div>
          <div class="col-12" v-if="!!salesOrder.id">
            <establishment-inactive-alert
              :establishment="salesOrder.establishment"
            />
          </div>
          <div
            class="col-12 justify-content-center justify-content-sm-between flex-wrap tabs-wrapper"
          >
            <tabs
              fill
              class="flex-column flex-md-row"
              tabNavWrapperClasses="nav-wrapper"
              tabNavClasses="nav nav-pills nav-fill"
              value="details"
              :key="renderKey"
            >
              <card shadow>
                <tab-pane title="global" id="1" :active="false">
                  <span slot="title">
                    <i class="ni ni-cloud-upload-96" />
                    {{ $t("COMMON.GLOBAL") }}
                  </span>
                  <sales-order-view-global :salesOrder="salesOrder" />
                </tab-pane>

                <tab-pane
                  title="client-validation"
                  id="2"
                  :active="false"
                  v-if="
                    !usesInvoiceDispatchFlow &&
                    [
                      CLIENT_VALIDATED_STATUS_PENDING,
                      CLIENT_VALIDATED_STATUS_VALIDATED,
                      CLIENT_VALIDATED_STATUS_CANCELED,
                    ].includes(salesOrder.client_validated_status)
                  "
                >
                  <span slot="title">
                    <i class="ni ni-circle-08" />
                    {{ $t("SALES_ORDERS.CLIENT_VALIDATION") }}
                  </span>
                  <sales-order-view-client-validation
                    :salesOrder="salesOrder"
                  />
                </tab-pane>

                <tab-pane title="details" id="3" :active="false">
                  <span slot="title">
                    <i class="ni ni-bullet-list-67" />
                    {{ $t("COMMON.DETAILS") }}
                  </span>
                  <sales-order-view-details
                    :salesOrder="salesOrder"
                    @salesOrderItemsUpdated="get"
                    @onSalesOrderUpdated="get"
                  />
                </tab-pane>

                <tab-pane
                  title="details"
                  id="4"
                  :active="false"
                  v-if="
                    $currentUserCan($permissions.PERM_VIEW_ANY_SALES_INVOICES)
                  "
                >
                  <span slot="title">
                    <i class="ni ni-single-copy-04" />
                    {{ $t("SALES_ORDERS.SALES_INVOICES") }}
                  </span>
                  <sales-order-view-invoices
                    :salesOrder="salesOrder"
                    @salesOrderInvoicesUpdated="get"
                  />
                </tab-pane>

                <tab-pane
                  title="details"
                  id="5"
                  :active="false"
                  v-if="
                    $currentUserCan($permissions.PERM_VIEW_ANY_SALES_DELIVERIES)
                  "
                >
                  <span slot="title">
                    <i class="fa fa-truck" />
                    {{ $t("SALES_ORDERS.DELIVERIES_STATE") }}
                  </span>
                  <sales-order-view-delivery-state
                    :salesOrder="salesOrder"
                    @salesOrderDeliveriesUpdated="get"
                  />
                </tab-pane>

                <tab-pane
                  title="details"
                  id="6"
                  :active="false"
                  v-if="
                    $currentUserCan($permissions.PERM_VIEW_ANY_SALES_DELIVERIES)
                  "
                >
                  <span slot="title">
                    <i class="fa fa-truck" />
                    {{ $t("COMMON.SALES_DELIVERIES") }}
                  </span>
                  <sales-order-view-deliveries
                    :salesOrder="salesOrder"
                    @salesOrderDeliveriesUpdated="get"
                  />
                </tab-pane>

                <tab-pane
                  title="files"
                  id="998"
                  v-if="
                    $currentUserCan($permissions.PERM_VIEW_ANY_FILES) &&
                    salesOrder.organization
                  "
                >
                  <span slot="title">
                    <i class="ni ni-folder-17" />
                    {{ $t("COMMON.FILES") }}
                  </span>
                  <list-file-component :object="salesOrder" />
                </tab-pane>

                <tab-pane
                  title="logs"
                  id="999"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
                >
                  <span slot="title">
                    <i class="fa fa-file" />
                    {{ $t("COMMON.LOGS") }}
                  </span>
                  <sales-order-view-logs :salesOrder="salesOrder" />
                </tab-pane>
              </card>
            </tabs>
          </div>
        </div>
      </card>
    </div>

    <sales-order-view-add-delivery-form
      v-if="!salesOrder.deliveryItemsState.orderDelivered"
      :salesOrder="salesOrder"
      :showModal="salesOrderDeliveryFormModalOpened"
      @closeSalesOrderDeliveryForm="
        () => {
          salesOrderDeliveryFormModalOpened = false;
        }
      "
    />

    <sales-order-view-add-invoice-form
      v-if="!salesOrder.invoicingItemsState.orderInvoiced"
      :salesOrder="salesOrder"
      :showModal="salesOrderInvoiceFormModalOpened"
      @closeSalesOrderInvoiceForm="
        () => {
          salesOrderInvoiceFormModalOpened = false;
        }
      "
    />
    <modal
      v-if="showMailModal"
      :show="showMailModal"
      modal-classes="modal-secondary"
      size="xl"
    >
      <sales-order-mail-modal-content
        :salesOrder="salesOrder"
        :get="get"
        :toggleMailModal="toggleMailModal"
      />
    </modal>
    <modal
      v-if="showSubsidizedMailModal"
      :show="showSubsidizedMailModal"
      modal-classes="modal-secondary"
      size="xl"
    >
      <sales-order-subsidized-invoice-mail-modal-content
        :salesOrder="salesOrder"
        :get="get"
        :toggleMailModal="toggleSubsidizedMailModal"
        :alreadySent="subsidizedInvoiceAlreadySent"
        @sent="get"
      />
    </modal>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { cloneDeep } from "lodash";
import swal from "sweetalert2";
import {
  ORDER_STATUS_CANCELED,
  ORDER_STATUS_DRAFT,
  ORDER_STATUS_VALIDATED,
  INVOICING_STATUS_INVOICED,
  DELIVERY_STATUS_DELIVERED,
  ORDER_STATUS_COMPLETED,
} from "@/constants/orders";
import {
  CLIENT_VALIDATED_STATUS_DRAFT,
  CLIENT_VALIDATED_STATUS_PENDING,
  CLIENT_VALIDATED_STATUS_CANCELED,
  CLIENT_VALIDATED_STATUS_VALIDATED,
} from "@/constants/salesOrders";
import {
  PRICING_TYPE_SUBSIDIZED,
  PRICING_TYPE_COUPONS,
  salesOrderRequiresClientValidation,
} from "@/constants/pricingTypes";
import { openPdfBlob } from "@/helpers/downloadPdf";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { Tabs, TabPane } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import SalesOrderViewGlobal from "./partials/SalesOrderViewGlobal.vue";
import SalesOrderViewDetails from "./partials/SalesOrderViewDetails.vue";
import SalesOrderViewLogs from "./partials/SalesOrderViewLogs.vue";
import defaultSalesOrder from "./defaultSalesOrder";
import SalesOrderViewAddDeliveryForm from "./partials/SalesOrderViewAddDeliveryForm.vue";
import SalesOrderViewAddInvoiceForm from "./partials/SalesOrderViewAddInvoiceForm.vue";
import SalesOrderViewDeliveries from "./partials/SalesOrderViewDeliveries.vue";
import SalesOrderViewDeliveryState from "./partials/SalesOrderViewDeliveryState.vue";
import SalesOrderViewInvoices from "./partials/SalesOrderViewInvoices.vue";
import SalesOrderMailModalContent from "./partials/SalesOrderMailModalContent";
import SalesOrderSubsidizedInvoiceMailModalContent from "./partials/SalesOrderSubsidizedInvoiceMailModalContent.vue";
import SalesOrderViewClientValidation from "./partials/SalesOrderViewClientValidation";
import EstablishmentInactiveAlert from "@/views/Pages/CafeteriaModule/EstablishmentManagement/partials/EstablishmentInactiveAlert.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    SalesOrderViewGlobal,
    SalesOrderViewDetails,
    SalesOrderViewLogs,
    ListFileComponent,
    NotificationSubscription,
    SalesOrderViewAddDeliveryForm,
    SalesOrderViewAddInvoiceForm,
    SalesOrderViewDeliveries,
    SalesOrderViewDeliveryState,
    SalesOrderViewInvoices,
    SalesOrderMailModalContent,
    SalesOrderSubsidizedInvoiceMailModalContent,
    SalesOrderViewClientValidation,
    EstablishmentInactiveAlert,
  },

  mixins: [requestErrorMixin],

  data() {
    return {
      loading: false,
      showMailModal: false,
      showSubsidizedMailModal: false,
      salesOrder: cloneDeep(defaultSalesOrder),
      ORDER_STATUS_DRAFT: ORDER_STATUS_DRAFT,
      ORDER_STATUS_COMPLETED,
      ORDER_STATUS_CANCELED: ORDER_STATUS_CANCELED,
      ORDER_STATUS_VALIDATED: ORDER_STATUS_VALIDATED,
      INVOICING_STATUS_INVOICED: INVOICING_STATUS_INVOICED,
      DELIVERY_STATUS_DELIVERED: DELIVERY_STATUS_DELIVERED,
      CLIENT_VALIDATED_STATUS_DRAFT: CLIENT_VALIDATED_STATUS_DRAFT,
      CLIENT_VALIDATED_STATUS_PENDING: CLIENT_VALIDATED_STATUS_PENDING,
      CLIENT_VALIDATED_STATUS_CANCELED: CLIENT_VALIDATED_STATUS_CANCELED,
      CLIENT_VALIDATED_STATUS_VALIDATED: CLIENT_VALIDATED_STATUS_VALIDATED,
      PRICING_TYPE_SUBSIDIZED: PRICING_TYPE_SUBSIDIZED,
      PRICING_TYPE_COUPONS: PRICING_TYPE_COUPONS,
      salesOrderDeliveryFormModalOpened: false,
      salesOrderInvoiceFormModalOpened: false,
      renderKey: 0,
      isFetchingSalesOrder: false,
      hasPendingSalesOrderFetch: false,
    };
  },

  computed: {
    isEstablishmentInactive() {
      return !!(
        this.salesOrder.establishment &&
        this.salesOrder.establishment.active === false
      );
    },
    canCancelSalesOrder() {
      if (this.salesOrder.invoicing_status === INVOICING_STATUS_INVOICED) {
        return false;
      }
      if (
        this.salesOrder.status === ORDER_STATUS_CANCELED ||
        this.salesOrder.status === ORDER_STATUS_DRAFT
      ) {
        return false;
      }
      if (this.salesOrder.status === ORDER_STATUS_VALIDATED) {
        return true;
      }
      return false;
    },
    /**
     * Ces soumissions ne s'envoient pas comme une soumission classique : elles
     * passent par « générer et envoyer la facture », sans validation client.
     */
    usesInvoiceDispatchFlow() {
      return !salesOrderRequiresClientValidation(this.salesOrder);
    },

    /**
     * True iff the subsidized invoice has already been emailed to the client.
     *
     * BOTH conditions are required:
     *  - `invoicing_status === INVOICED` — guards against historical orders
     *    where `sent_at` exists but no non-canceled invoice currently does
     *    (e.g. the only invoice was canceled afterwards).
     *  - `sent_at` truthy — guards against orders whose invoice was created
     *    via the generic "Créer la facture" button (which flips
     *    invoicing_status to INVOICED WITHOUT sending any email). Without
     *    this check the button would label itself "Renvoyer la facture"
     *    and prompt the confirm-resend modal for an invoice never emailed.
     */
    subsidizedInvoiceAlreadySent() {
      if (!this.salesOrder.sent_at) {
        return false;
      }
      return this.salesOrder.invoicing_status === INVOICING_STATUS_INVOICED;
    },
  },

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      if (this.isFetchingSalesOrder) {
        this.hasPendingSalesOrderFetch = true;
        return;
      }

      this.isFetchingSalesOrder = true;

      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("salesOrders/get", id);
        this.salesOrder = this.$store.getters["salesOrders/salesOrder"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.isFetchingSalesOrder = false;

        if (this.hasPendingSalesOrderFetch) {
          this.hasPendingSalesOrderFetch = false;
          await this.get();
        }
      }
    },

    async editSalesOrder(row) {
      this.$router.push({
        name: "Edit SalesOrder",
        params: { id: this.salesOrder.id },
      });
    },

    async validateSalesOrder() {
      try {
        this.loading = true;
        await this.$store.dispatch("salesOrders/validate", this.salesOrder.id);
        this.salesOrder = this.$store.getters["salesOrders/salesOrder"];
        this.$notify({
          type: "success",
          message: this.$t("SALES_ORDERS.SALES_ORDER_VALIDATED_BO"),
        });
        await this.get();
        this.loading = false;

        // Propose to send the submission immediately, when sending by email is applicable.
        const canSend =
          !this.usesInvoiceDispatchFlow &&
          this.salesOrder.status !== ORDER_STATUS_DRAFT &&
          this.salesOrder.status !== ORDER_STATUS_CANCELED &&
          [CLIENT_VALIDATED_STATUS_DRAFT, CLIENT_VALIDATED_STATUS_PENDING].includes(
            this.salesOrder.client_validated_status
          );
        if (canSend) {
          const send = await swal.fire({
            title: this.$t("SALES_ORDERS.SEND_NOW_QUESTION"),
            text: this.$t("SALES_ORDERS.SEND_NOW_HINT"),
            icon: "question",
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: this.$t("COMMON.YES"),
            cancelButtonText: this.$t("COMMON.NO"),
            confirmButtonClass: "btn btn-primary",
            cancelButtonClass: "btn btn-warning",
          });
          if (send.isConfirmed) {
            this.toggleMailModal();
          }
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async recalculatePricing() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "salesOrders/recalculate",
          this.salesOrder.id
        );
        this.salesOrder =
          this.$store.getters["salesOrders/salesOrder"];
        this.$notify({
          type: "success",
          message: this.$t("COMMON.RECALCULATE_SUCCESS"),
        });
        await this.get();
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.loading = false;
      }
    },

    async revertToDraft() {
      try {
        const confirm = await swal.fire({
          title: this.$t(`SALES_ORDERS.CONFIRM_REVERT_TO_DRAFT`),
          icon: "error",
          confirmButtonText: this.$t("COMMON.OK"),
          cancelButtonText: this.$t("COMMON.CANCEL"),
          showCancelButton: true,
          confirmButtonClass: "btn btn-primary",
          cancelButtonClass: "btn btn-warning",
        });
        if (!confirm.isConfirmed) {
          return;
        }

        this.loading = true;
        await this.$store.dispatch(
          "salesOrders/revertToDraft",
          this.salesOrder.id
        );
        this.salesOrder = this.$store.getters["salesOrders/salesOrder"];
        this.$notify({
          type: "success",
          message: this.$t("SALES_ORDERS.SALES_ORDER_REVERTED"),
        });
        this.loading = false;
      } catch (error) {
        console.log(error);
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async cancelSalesOrder() {
      const confirmation = await swal.fire({
        title: this.$t("SALES_ORDERS.CANCEL_SALES_ORDER_QUESTION"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      if (!confirmation.value) {
        return;
      }

      try {
        this.loading = true;
        await this.$store.dispatch("salesOrders/cancel", this.salesOrder.id);
        this.salesOrder = this.$store.getters["salesOrders/salesOrder"];
        this.$notify({
          type: "success",
          message: this.$t("SALES_ORDERS.SALES_ORDER_CANCELED"),
        });
        this.loading = false;
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    toggleMailModal() {
      this.showMailModal = !this.showMailModal;
      this.get();
    },

    toggleSubsidizedMailModal() {
      this.showSubsidizedMailModal = !this.showSubsidizedMailModal;
      this.get();
    },

    async openSubsidizedInvoiceModal() {
      if (this.subsidizedInvoiceAlreadySent) {
        const confirmation = await swal.fire({
          title: this.$t("SALES_ORDERS.CONFIRM_RESEND_INVOICE"),
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: this.$t("COMMON.YES"),
          cancelButtonText: this.$t("COMMON.NO"),
          confirmButtonClass: "btn btn-primary",
          cancelButtonClass: "btn btn-warning",
        });
        if (confirmation.value !== true) {
          return;
        }
      }
      this.showSubsidizedMailModal = true;
    },

    async deleteSalesOrder() {
      const confirmation = await swal.fire({
        title: this.$t("SALES_ORDERS.DELETE_THIS_SALES_ORDER"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("salesOrders/destroy", this.salesOrder.id);
          await this.goBack();
          this.$notify({
            type: "success",
            message: this.$t("SALES_ORDERS.SALES_ORDER_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    goBack() {
      this.$router.push({ name: "List SalesOrders" });
    },

    async print() {
      swal.fire({
        title: `Chargement`,
        onBeforeOpen: () => {
          swal.showLoading();
        },
      });
      try {
        const response = await this.$store.dispatch(
          "salesOrders/print",
          this.salesOrder.id
        );

        openPdfBlob(response, `${this.salesOrder.seq_number || this.salesOrder.code}.pdf`);

        swal.close();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, something went wrong!",
        });
        this.setApiValidation(error.response.data.errors);
        swal.close();
      }
    },
  },
};
</script>
